import { Box } from '@chakra-ui/react'
import type { AppInfoMessage, AppInfoMessagePagedQuery } from 'BrokerTsLib/src/dtos'
import { useGetAllAppInfoMessages, useGetAppInfoMessage } from 'brokertslib/src/hooks/useAppInfoMessage'
import { useEffect, useState } from 'react'
import { useParams } from 'react-router'

import { Container } from '../../components/Container'
import { Loading } from '../../components/Loading'
import { Section } from '../../components/Section'
import { NewsDetail } from '../../containers/news/NewsDetail'
import { PageContent } from '../../containers/PageContent'
import { useApp } from '../../hooks/useApp'

export const NewsDetailPage = () => {
  const { id } = useParams()

  const { product } = useApp()

  const pageSize = 9

  const [currentPage, setCurrentPage] = useState(1)
  const [filter, setFilter] = useState<AppInfoMessagePagedQuery>({
    pageSize: pageSize,
    pageIndex: currentPage,
    product: product!,
    excludeId: parseInt(id!),
    shown: true
  })

  const { mutateAsync: getMessages, data: dataMessages, isPending: isLoadingMessages } = useGetAllAppInfoMessages()
  const otherNews = (dataMessages?.data?.items ?? []) as AppInfoMessage[]
  const totalCount = dataMessages?.data?.totalCount ?? 0

  const { data: appInfoMessage, isLoading: isLoadingMessage, isFetched, refetch } = useGetAppInfoMessage(id!)

  useEffect(() => {
    if (id)
      refetch()
  }, [id])

  useEffect(() => {
    if (product) {
      getMessages(filter)
    }
  }, [filter])

  useEffect(() => {
    setFilter({
      ...filter,
      pageIndex: currentPage
    })
  }, [currentPage])

  useEffect(() => {
    setFilter({
      ...filter,
      product: product!,
      excludeId: parseInt(id!)
    })
  }, [product, id])

  if (!product)
    return null

  return (
    <Section>
      <Container>
        <PageContent>
          {isLoadingMessage && <Loading large={true} />}

          {!isLoadingMessage && !appInfoMessage && isFetched && <Box>Aktualita nenalezena</Box>}

          {!isLoadingMessage && appInfoMessage &&
            <NewsDetail
              {...appInfoMessage}
              otherNews={otherNews}
              isLoadingMessages={isLoadingMessages}
              totalCount={totalCount}
              currentPage={currentPage}
              setCurrentPage={setCurrentPage}
              pageSize={pageSize}
            />
          }

        </PageContent>
      </Container>
    </Section>
  )
}
